import * as angular from 'angular';

function clickToCopy() {
    return {
        link(scope, element) {
            element.bind('click', () => {
                if(!element || !element.select) return;
                element.select();
                document.execCommand('copy');
            });

            if(!element.attr('title')) element.attr('title', 'Click to copy');
        }
    };
}

export default angular.module('directives.clickToCopy', [])
    .directive('clickToCopy', clickToCopy)
    .name;
